module.exports = __webpack_public_path__ + "static/media/SchoolCosSchoolReceive2.3a4a00a1.png";